import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// import 'amfe-flexible'
import '@/util/rem.js'

Vue.config.productionTip = false
Vue.use(ElementUI);

router.beforeEach((to, from, next)=>{
  var type = '/pc'
  if (navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)) {
    type = '/mb'
  }
  if (to.path === '/') {
    next(type+'/home')
  } else if(to.path.split('/')[1] != 'pc' && to.path.split('/')[1] != 'mb') {
    next(type + to.path)
  } else if(type !== '/'+to.path.split('/')[1]) {
    next(type + '/' + to.path.split('/')[2])
  } else {
    next()
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
